import { createPrefetchableAsyncPaginatedDataContext, pageDataErrorHandler } from '#src/app/shared/contexts/asyncData';

import { getFirstPageData, getNextPageData } from './api';
import type { DecisionMakerPageDataErrorCode } from './types';

/** @knip-ignore */
export const {
	Context: DMProfilePagePaginatedTargetedPetitionsDataContext,
	Provider: DMProfilePagePaginatedTargetedPetitionsDataContextProvider,
	useContext: useDMProfilePagePaginatedTargetedPetitionsData,
	useAsyncData: useDMProfilePagePaginatedTargetedPetitionsDataFromApi,
	prefetchAsyncData: prefetchDMProfilePagePaginatedTargetedPetitionsDataFromApi,
} = createPrefetchableAsyncPaginatedDataContext({
	name: 'DMProfilePagePaginatedTargetedPetitionsDataContext',
	dataProperty: 'targetedPetitionsPaginatedData',
	getFirstPageData,
	getNextPageData,
	getUniqueId: (slug) => slug,
	errorHandler: pageDataErrorHandler<DecisionMakerPageDataErrorCode>(),
});
